<template>
  <footer class="app-footer">
    <div class="footer-content">
      <span>
        Copyright &copy;
        <a href="https://github.com/ameneblf" target="_blank" rel="noopener noreferrer">Medamene</a>
        <span class="footer-separator">•</span>
        v1.26.01
      </span>
    </div>
  </footer>
</template>

<style scoped>
.app-footer {
  width: 100%;
  padding: 18px 24px;
  text-align: center;
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
}

.app-footer .footer-content {
  margin: 0 auto;
  max-width: 1280px;
}

.app-footer a {
  color: #60758b;
  font-weight: 700;
  text-decoration: none;
  transition: color .2s ease;
}

.app-footer a:hover {
  color: #ff9f43;
  text-decoration: underline;
}

.footer-separator {
  margin: 0 7px;
  color: #c4ced8;
}

@media (max-width: 575px) {
  .app-footer {
    font-size: 11px;
    padding: 14px 16px;
  }
}
</style>
